import React from "react";
import { Spinner } from "components";

const Callback = () => {
  return <Spinner message={"Authenticating"} />;
};

export default Callback;
